var _defs, _circle, _path, _ellipse, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "communicationsSvg",
    "data-name": "communications",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Comm-cls-1,.Comm-cls-3{fill:#14163d;}.Comm-cls-2{fill:#49ff40;}.Comm-cls-3{stroke:#49ff40;stroke-miterlimit:10;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Comm-cls-1",
    cx: 70,
    cy: 70,
    r: 70
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Comm-cls-2",
    d: "M137.76,139S130,173.92,149.4,193.32s48.5,5.82,48.5,5.82Z",
    transform: "translate(-106 -97)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "Comm-cls-3",
    cx: 169,
    cy: 168,
    rx: 7.07,
    ry: 43.44,
    transform: "translate(-175.29 71.71) rotate(-45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Comm-cls-2",
    d: "M196.76,136.84c.23.7-30.28,24.68-30.28,24.68s-1.09,3.27,2.18,6.54,6.54,2.18,6.54,2.18l24-30.52Z",
    transform: "translate(-106 -97)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "Comm-cls-2",
    cx: 93.17,
    cy: 40.54,
    r: 4.36
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunications);
export default __webpack_public_path__ + "static/media/Communications.8f51f72976ca63ed5a93ab31a06377a9.svg";
export { ForwardRef as ReactComponent };